import { createActionTypes } from 'utils/action/actionTypes';

export const CHARGER_STATUS = createActionTypes('CHARGER_STATUS');
export const CHARGER_STATUS_SILENT = createActionTypes('CHARGER_STATUS_SILENT'); // no skeleton loader
export const FETCH_CHARGER_STATUS_WIDGETS = createActionTypes('FETCH_CHARGER_STATUS_WIDGETS');
export const CHARGER_STATUS_DOWNLOAD = createActionTypes('CHARGER_STATUS_DOWNLOAD');

export const SET_SELECTED_STATUSES = 'SET_SELECTED_STATUSES';
export const TOGGLE_LIVE_MODE = 'TOGGLE_LIVE_MODE';
export const RESET_LIVE_MODE = 'RESET_LIVE_MODE';
export const PUBNUB_STATUS_UPDATE = 'PUBNUB_STATUS_UPDATE';
